<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
                <b-card>
                    <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
                    <form action="">
                        <div class="form-row">
                            <div class="col-md-6 col-sm-6 col-lg-5">
                                <label class="col-form-label col-form-label-sm" for="batch_id">Select Batch <span
                                        style="color: red">*</span></label>
                                <select v-model="search_data.batch_id" v-validate="'required'" id="batch_id" name="batch_id"
                                        class="form-control form-control-sm">
                                    <option :value="''" selected>Select Batch</option>
                                    <option :key="index" :value="batch.id" v-for="(batch, index) in batches">
                                        {{batch.trade.desc + " | " + "Batch No: " + batch.batch_no }}
                                    </option>
                                </select>
                                <div class="invalid-feedback">
                                    Please Select Batch
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-6 col-lg-5" style="padding-top: 2px;">
                                <label for="attendance_date">Attendance Date <span style="color: red">*</span></label>
                                <datepicker  v-model="search_data.attendance_date" v-validate="'required'"
                                             id="attendance_date" name="attendance_date" :format="customAttendanceDate" :disabled-dates="disabledDates" placeholder="Attendance Date" ></datepicker>
                                <div class="text-danger" style="margin-top: 0.25rem; font-size: 0.75rem;" v-if="errors.has('attendance_date')">
                                    Attendance date required
                                </div>
                            </div>
                            <div  class="col-md-6 col-sm-6 col-lg-2 custom-search">
                                <button class="btn btn-success btn-sm custom-search-button" @click.prevent="search">
                                    Search
                                </button>
                            </div>
                        </div>
                    </form>
                </b-card>
                <b-card v-if="!flag">
                    <div v-if="attendances.length > 0" class="row mb-2">
                        <div class="col-sm-4">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ attendances.length }}</span>
                        </div>
                    </div>
                    <form action="">
                        <div class="table-responsive" style="overflow-x: auto">
                            <table class="table table-centered table-striped">
                                <thead>
                                <tr>
                                    <th>Sl</th>
                                    <th>Name</th>
                                    <th>Father Name</th>
                                    <th>Village</th>
                                    <th>Present</th>
                                    <th>Absent</th>
                                    <th>Remarks</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(trainee, index) in attendances" :key="index">
                                    <td>{{ index + 1 }}</td>
                                    <td>
                                        <router-link :to="{name: 'traineeView', params: { trainee_id: trainee.trainee_id }}"
                                                     tag="a" target="_blank">{{ trainee.rep_name ?  trainee.rep_name : trainee.name }}
                                        </router-link>
                                    </td>
                                    <td>{{ trainee.rep_father_husband_name ?  trainee.rep_father_husband_name : trainee.father_husband_name }}</td>
                                    <td>{{ trainee.desc }}</td>
                                    <td>
                                        <input type="radio" v-model="attendances[index].is_attend"
                                               :name="'attendance-' + index" :value="1" class="present c-container"/>
                                    </td>
                                    <td>

                                        <input  type="radio" v-model="attendances[index].is_attend"
                                                :name="'attendance-' + index" :value="0" class="absent c-container"/>
                                    </td>
                                    <td>
                                        <input  type="text" v-model="attendances[index].remarks"
                                                :name="'remarks-' + index" class="form-control form-control-sm remarks c-container"/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <span  v-if="userPermission.includes('attendance-create') || userPermission.includes('attendance-edit')" >
                            <button class="btn btn-success waves-effect waves-light mr-2" @click.prevent="save">Save</button>
                        </span>

                    </form>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>
    import moment from "moment";
    import Datepicker from "vuejs-datepicker";

    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Attendance",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader, Datepicker},
        data() {
            return {
                title: "Attendance",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Attendance",
                        href: "/trainee/attendance/add",
                        active: true
                    }
                ],
                batches: [],
                search_data: {
                    batch_id: '',
                    attendance_date: '',
                },
                attendances: {},
                trainee: {},
                flag: true,
                validation_errors: {},
                show: false,
                checkedData: true,
                disabledDates: {
                    from: new Date(Date.now())
                },
            };
        },
        mounted() {
            this.getBatches();
        },
        methods: {
            getBatches() {
                http.get("api/batch/trainee/attendance/getBatch").then(response => {
                    if (!response.error) {
                        this.batches = response.data.batches;
                    }
                });
            },
            customAttendanceDate(date) {
                this.search_data.attendance_date = moment(date).format("YYYY-MM-DD");
                return moment(date).format("YYYY-MM-DD");
            },

            search() {
                this.$validator.validate().then(valid => {
                    if (valid) {
                        http
                            .post("api/trainee/attendance/search", this.search_data)
                            .then(response => {
                                // if (!response.error) {
                                if (response.data.error === false) {
                                    this.flag = false;
                                    this.attendances = response.data.attendances;
                                }
                                if(response.data.error === true){
                                    this.$bvToast.toast(response.data.message, {
                                        title: "Error",
                                        autoHideDelay: 5000,
                                        variant: "danger"
                                    });
                                }
                            })
                            .catch(error => {
                                this.validation_errors = error.response.data.errors;
                                this.$bvToast.toast(error.response.data.message, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            });
                    }
                });
            },
            save() {
                http
                    .post("api/trainee/attendance/store", {
                        attendances: this.attendances,
                        attendance_date: this.search_data.attendance_date,
                        batch_id: this.search_data.batch_id,
                    })
                    .then(response => {
                        if (!response.data.error) {
                            if (response.data.permissionError) {
                                this.$bvToast.toast(response.data.permissionError, {
                                    title: "Error",
                                    autoHideDelay: 5000,
                                    variant: "danger"
                                });
                            } else {
                                this.$bvToast.toast(response.data.message, {
                                    title: "Success",
                                    autoHideDelay: 5000,
                                    variant: "success"
                                });
                            }
                        } else {
                            this.$bvToast.toast(response.data.message, {
                                title: "Error",
                                autoHideDelay: 5000,
                                variant: "danger"
                            });
                        }
                    }).catch(error => {
                    this.$bvToast.toast(error.response.data.errors, {
                        title: "Success",
                        autoHideDelay: 5000,
                        variant: "success"
                    });
                });
            }
        },
        computed: {
            userPermission () {
                return this.$store.state.user
            }
        },
        created () {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>

<style lang="scss">
    .vdp-datepicker input {
        width: 100%;
        border-radius: 3px;
        border: 1px solid #ced4da;
        height: 30px;
        padding-left: 15px;
        color: #6b757d;
    }

    .c-container {
        margin-right: 5px;
    }
</style>
